import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { QualityGoals } from 'src/app/appModel/QualityGoalModels/selected-quarter-and-date';
import { DefineService } from 'src/app/appServices/DefineService/define-service';
import { Modules, LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { Workbook } from 'exceljs';
import { Subscription } from 'rxjs';
import { selectedQuarterOptions } from 'src/app/appWeb/shared/shared';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { allQualityGoal, editQualityGoal } from 'src/app/appWeb/shared/shared-interface';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';

@Component({
  selector: 'app-quality-goals',
  templateUrl: './quality-goals.component.html',
  styleUrls: ['./quality-goals.component.scss'],
})
export class QualityGoalsComponent implements OnInit {
  @ViewChild('quarter') quarter: Table | undefined;
  date: any = new Date();
  date1: any = new Date();
  addQualityGoalDate = new Date();

  productDialogForEditQuarter!: boolean;
  // qualityGoal: any = [];
  allQualityGoal: Array<allQualityGoal> = [];
  editQualityGoal: Array<editQualityGoal> = [];
  id: string | null = '';
  FacilityID: string = '';
  FacilityName: string = '';
  selectedQuarterOptions= selectedQuarterOptions;
  selectedQuarter: string | null = '';
  disableYear!: boolean;
  disableQuarter!: boolean;
  quarter1: boolean = true;
  quarter2: boolean = true;
  quarter3: boolean = true;
  quarter4: boolean = true;
  addFacilityGoalsResponseObj: any = {};
  qualityGoalScenario:string = "";
  facilityGoalsStr:string = "";
  noRecordBool:boolean = false;
  showProgressSpinner: boolean = false;
  onClickDisable: boolean = false;
  facilityExistsMessage:string = "";
  totalRecords: number = 0;
  pageNumber: number = 1;
  rows: number = 15;
  sortOrder: string = 'Asc';
  sortCol: string = '';
  filterVal: string = '';
  TotalFacilities!: number;
  isAccessReadWrite: boolean = false;
  roleAccessResult: any = [];
  UId: string | null= '';
  RoleName: string | null= '';
  isAccessRead: boolean = false;
  quarterfacilityLoader: boolean = false;
  exportExcelLoader: boolean = false;
  private subscription: Subscription[] = [];
  roleForFacility: boolean = false;

  constructor(
    private defineService: DefineService,
    private helperService: HelperService,
    private messageService: MessageService,
    public PiTeamService: PiteamService,
    private router: Router,
    private accessControlService: AccessControlService,
    private authService: AuthService
  ) {
    // this.qualityGoal = new QualityGoals();
  }

  ngOnInit(): void {
    this.FacilityName = this.helperService.decryption(localStorage.getItem(LocalStorage.FacilityName));
    this.id = this.helperService.decryption(localStorage.getItem(LocalStorage.FacilityID));
    this.TotalFacilities = this.helperService.decryption(localStorage.getItem(LocalStorage.TotalFacilities));
    this.FacilityID = this.helperService.decryption(localStorage.getItem(LocalStorage.FacilityID));
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    this.editFacility();
    this.getAllFacilities();
    this.PiTeamService.currentDateTime();
  }

  editFacility() {
    const currentYear = new Date(this.date1).getFullYear();
    this.showProgressSpinner = true;
    this.subscription.push(
    this.defineService.GetQuarterDataFacility(this.FacilityID, currentYear).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.editQualityGoal = res.data;//(res.data.splice(2)); 
          this.GetFacilityQualityQuarterdata(this.editQualityGoal);
          let index = this.editQualityGoal.findIndex((x: any) =>x.FieldName ==  'Door to NIR Callback Time');
          if (index > -1) {
            this.editQualityGoal.splice(index, 1); 
          }
          this.showProgressSpinner = false;

        }

        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.FBRead, MenuItemsAccess.FBReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;

      },
      error: (err: any) => {
      },
    })
    );
  }

  getQuarterDataInEditFacility(date1: number) {
    let date = date1;
    this.showProgressSpinner = true;
    this.subscription.push(
    this.defineService.GetQuarterDataFacility(this.id, date).subscribe({
      next: (res: any) => {
        if (res.data) {

          if (res.data.length == 0) { this.noRecordBool = true; }
          else { this.noRecordBool = false; }
          this.editQualityGoal = res.data; //res.data.splice(2)
          this.GetFacilityQualityQuarterdata(this.editQualityGoal);
          var index = this.editQualityGoal.findIndex((x: any) =>x.FieldName ==  'Door to NIR Callback Time');
          if (index > -1) {
            this.editQualityGoal.splice(index, 1); 
          }
          var index = this.editQualityGoal.findIndex((x: any) =>x.FieldName ==  'Door to NIR Callback Time');
          if (index > -1) {
            this.editQualityGoal.splice(index, 1); 
          }
          this.PiTeamService.currentDateTime();
          this.showProgressSpinner = false;
        }
      },
      error: (err: any) => {
      },
    })
    );
  }

  hideProductDialogForEditQuarter() {
    this.messageService.clear();
    this.messageService.add({ key: 'c', sticky: true, severity: 'custom', summary: 'Are you sure you want to close out of this page?' });
  }
 
  AddQualityGoals() {
    this.onClickDisable = true;
    this.facilityGoalsStr = "Add Facility Benchmarks";
    this.addFacilityGoalsResponseObj = null;
    this.productDialogForEditQuarter = true;
    this.selectedQuarter = null;
    this.disableYear = false;
    this.disableQuarter = false;
  }

  EditQulityGoalsByQuarter(quarter: string) {
    this.onClickDisable = false;
    this.productDialogForEditQuarter = true;
    this.addFacilityGoalsResponseObj = {};
    this.disableYear = true;
    this.disableQuarter = true;
    this.addQualityGoalDate = this.date1;
    this.selectedQuarter = quarter;
    this.selectedQuartersAndDateEdit();
  }

  selectedQuartersAndDateEdit() {
    this.qualityGoalScenario = "Edit";
    this.facilityGoalsStr = "Edit Facility Benchmarks";
    if (this.selectedQuarter == "1") {
      this.editQualityGoal.forEach((item: any) => {
        this.addFacilityGoalsResponseObj[item.ColName] = item.Quarter1;
      });
    }
    if (this.selectedQuarter == "2") {
      this.editQualityGoal.forEach((item: any) => {
        this.addFacilityGoalsResponseObj[item.ColName] = item.Quarter2;
      });
    }
    if (this.selectedQuarter == "3") {
      this.editQualityGoal.forEach((item: any) => {
        this.addFacilityGoalsResponseObj[item.ColName] = item.Quarter3;
      });
    }
    if (this.selectedQuarter == "4") {
      this.editQualityGoal.forEach((item: any) => {
        this.addFacilityGoalsResponseObj[item.ColName] = item.Quarter4;
      });
    }
  }

  selectedQuartersAndDateAdd() {
    this.qualityGoalScenario = "Add";
    if (this.addQualityGoalDate != null && this.selectedQuarter != null) {
      this.showProgressSpinner = true;
      this.subscription.push(
      this.defineService
        .AddQualityGoals(
          this.id,
          this.addQualityGoalDate.getFullYear(),
          this.selectedQuarter
        )
        .subscribe({
          next: (res: any) => {
            this.facilityExistsMessage = res.facilityExists;
            if (this.facilityExistsMessage != "Quality Goals are Not Available") {
              this.facilityExistsMessage = this.facilityExistsMessage.concat('.If you Save this Previous Goals Value will be overwritten.');
              this.messageService.clear();
              this.messageService.add({key: 'productDialogForEditQuarter', severity: 'warn', summary: 'Warn', detail: this.facilityExistsMessage, sticky: true });
            }
            if (res.data) {
              this.addFacilityGoalsResponseObj = res.data;
              this.showProgressSpinner = false;
            }
          },
          error: (err: any) => {
          },
        })
        );
        this.onClickDisable = false;
    }
  }
  saveSelectedQuartersAndDate() {
    this.quarterfacilityLoader = true;
    this.onClickDisable = true;
    this.date1 = this.addQualityGoalDate;//auto year change on add
    if (this.qualityGoalScenario == "Edit") {
      let data = {
        Fac_key: this.id,
        Quater: null,
        fromMonth: null,
        qag_time_frame: this.addQualityGoalDate.getFullYear(),
        gd_key: this.addFacilityGoalsResponseObj.gd_key,
        gd_qag_key: this.addFacilityGoalsResponseObj.gd_qag_key,
        gd_quater: this.selectedQuarter,
        qag_DTN_grter_or_equal_30minutes_percent: this.addFacilityGoalsResponseObj.qag_DTN_grter_or_equal_30minutes_percent,
        qag_DTN_grter_or_equal_45minutes_percent: this.addFacilityGoalsResponseObj.qag_DTN_grter_or_equal_45minutes_percent,
        qag_DTN_grter_or_equal_60minutes_percent: this.addFacilityGoalsResponseObj.qag_DTN_grter_or_equal_60minutes_percent,
        qag_TS_notification_to_needle_grter_or_equal_30minutes_percent: null,
        qag_TS_notification_to_needle_grter_or_equal_45minutes_percent: null,
        qag_TS_notification_to_needle_grter_or_equal_60minutes_percent: null,
        qag_TS_notification_to_response_average_minute: this.addFacilityGoalsResponseObj.qag_TS_notification_to_response_average_minute,
        qag_TS_notification_to_response_median_minute: this.addFacilityGoalsResponseObj.qag_TS_notification_to_response_median_minute,
        qag_activation_to_assessment_time_avg_min: this.addFacilityGoalsResponseObj.qag_activation_to_assessment_time_avg_min,
        qag_activation_to_assessment_time_median_min: this.addFacilityGoalsResponseObj.qag_activation_to_assessment_time_median_min,
        qag_alteplase_administered: null,
        qag_assessment_to_thrombolytic_decision_making_median_min: this.addFacilityGoalsResponseObj.qag_assessment_to_thrombolytic_decision_making_median_min,
        qag_cpoe_order_to_needle_ave_min: null,
        qag_cpoe_order_to_needle_med_min: null,
        qag_door_to_TS_notification_ave_minutes: this.addFacilityGoalsResponseObj.qag_door_to_TS_notification_ave_minutes,
        qag_door_to_TS_notification_median_minutes: this.addFacilityGoalsResponseObj.qag_door_to_TS_notification_median_minutes,
        qag_door_to_needle_average: this.addFacilityGoalsResponseObj.qag_door_to_needle_average,
        qag_door_to_needle_median: this.addFacilityGoalsResponseObj.qag_door_to_needle_median,
        qag_Activation_to_Needle_mean_min: this.addFacilityGoalsResponseObj.qag_Activation_to_Needle_mean_min,
        qag_Activation_to_Needle_Median_min: this.addFacilityGoalsResponseObj.qag_Activation_to_Needle_Median_min,
        qag_door_to_nir_callback: this.addFacilityGoalsResponseObj.qag_door_to_nir_callback,
        qag_percent10_min_or_less_activation_EMS: this.addFacilityGoalsResponseObj.qag_percent10_min_or_less_activation_EMS,
        qag_percent10_min_or_less_activation_Inpt: null,
        qag_percent10_min_or_less_activation_PV: this.addFacilityGoalsResponseObj.qag_percent10_min_or_less_activation_PV,
        qag_percent_TS_at_bedside_grterthan10_minutes: null,
        qag_thrombolytic_decision_making_to_thrombolytic_administration_med_min: this.addFacilityGoalsResponseObj.qag_thrombolytic_decision_making_to_thrombolytic_administration_med_min,
        qag_thrombolytic_medicaldecision_to_administration_average_minutes: this.addFacilityGoalsResponseObj.qag_thrombolytic_medicaldecision_to_administration_average_minutes,
        qag_verbal_order_to_administration_average_minutes: this.addFacilityGoalsResponseObj.qag_verbal_order_to_administration_average_minutes,
        toMonth: null
      }
      this.addFacilityGoalsResponseObj = data;
    }
    if (this.qualityGoalScenario == "Add") {
      this.addFacilityGoalsResponseObj.Fac_key = this.id;
      this.addFacilityGoalsResponseObj.gd_quater = this.selectedQuarter;
      this.addFacilityGoalsResponseObj.qag_time_frame = this.addQualityGoalDate.getFullYear();
    }
    this.subscription.push(
    this.defineService
      .SaveSelectedQuartersAndDate(this.addFacilityGoalsResponseObj)
      .subscribe({
        next: (res: any) => {
          this.quarterfacilityLoader = false;
          this.addFacilityGoalsResponseObj = null;
          this.productDialogForEditQuarter = false;
          this.PiTeamService.currentDateTime();
          this.messageService.add({key: 'FacilityData',severity:'success', summary: 'Success', detail: 'Facility Benchmarks Added Successfuly.'});
          this.editQualityGoal = res.data;//(res.data.splice(2));
          this.GetFacilityQualityQuarterdata(this.editQualityGoal);
          let index = this.editQualityGoal.findIndex((x: any) =>x.FieldName ==  'Door to NIR Callback Time')
          if (index > -1) {
            this.editQualityGoal.splice(index, 1); 
          }
        },
        error: (err: any) => {
        },
      })
      );
  }

  applyFilterGlobalForQuarter($event: any, stringVal: any) {
    this.quarter!.filterGlobal(
      ($event.target as HTMLInputElement).value,
      stringVal
    );
  }

  getAllFacilities() {
    this.showProgressSpinner = true;
    let data = {
      Take: '',
      Skip: 0,
      Sort: {
        FieldName: 'FacilityName',
        Order: 'ASC',
      },
      Filter: {
        field: '',
        operator: '',
        value: this.filterVal,
        logic: '',
        filters: [],
      },
      searchString: this.filterVal,
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [],
    };

    var model = {
      request: data,
      roleName:this.RoleName,
      userId: this.UId,
      System: '',
      Facility: ''
    }

    this.subscription.push(
    this.defineService.GetAllFacilities(model).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.allQualityGoal = res.data;
          this.totalRecords = res.Total;
        }
        this.showProgressSpinner = false;
      },
      error: (err: any) => {
      },
    })
    );
  }

  updateFaciiltyData() {
    localStorage.setItem(LocalStorage.FacilityID, this.helperService.ecryption(this.FacilityID));
    this.id = this.FacilityID;
    this.editFacility();
  }

  changeRouter(value: any) {
    this.router.navigate([value])
  }
  routeBack() {
    let passedFacility =  this.defineService.GetSearchFacility().passedFacility;
    this.defineService.PassingSearchFacility(passedFacility, true);
      this.changeRouter(`/${Modules.Layout}/${Modules.Define}/${Modules.Facilities}`)
      this.messageService.clear();
  }
  onConfirm() {
    this.productDialogForEditQuarter = false;
    this.messageService.clear();
  }

  onReject() {
    this.messageService.clear();
  }

  GetFacilityQualityQuarterdata(value: any){

    const colNameToDefault:any = {
      "qag_door_to_TS_notification_ave_minutes": 10,
      "qag_door_to_TS_notification_median_minutes": 10,
      "qag_percent10_min_or_less_activation_EMS": 90,
      "qag_percent10_min_or_less_activation_PV": 75,
      "qag_activation_to_assessment_time_avg_min": 12,
      "qag_activation_to_assessment_time_median_min": 12,
      "qag_TS_notification_to_response_average_minute": 10,
      "qag_TS_notification_to_response_median_minute": 10,
      "qag_door_to_needle_average": 45,
      "qag_door_to_needle_median": 45,
      "qag_Activation_to_Needle_mean_min": 30,
      "qag_Activation_to_Needle_Median_min": 30,
      "qag_verbal_order_to_administration_average_minutes": 10,
      "qag_assessment_to_thrombolytic_decision_making_median_min": 10,
      "qag_thrombolytic_medicaldecision_to_administration_average_minutes": 8,
      "qag_thrombolytic_decision_making_to_thrombolytic_administration_med_min": 8,
      "qag_DTN_grter_or_equal_30minutes_percent": 50,
      "qag_DTN_grter_or_equal_45minutes_percent": 75,
      "qag_DTN_grter_or_equal_60minutes_percent": 85,
    };
  
    value.forEach((element: any) => {
      const defaultValue = colNameToDefault[element.ColName];
      if (defaultValue !== undefined) {
        element.Quarter1 = element.Quarter1 ?? defaultValue;
        element.Quarter2 = element.Quarter2 ?? defaultValue;
        element.Quarter3 = element.Quarter3 ?? defaultValue;
        element.Quarter4 = element.Quarter4 ?? defaultValue;
      }
    });
  }

  excelDownload(workbook: any, fileName: string) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    })
  }

  exportExcel() {
    this.exportExcelLoader = true;
    let newArray: any = [];

          if(this.editQualityGoal.length > 0){
            let editQualityGoal = this.editQualityGoal.slice(2)
            editQualityGoal.forEach((item:any)=>{
                newArray.push({FieldName: item.FieldName,Quarter1: item.Quarter1,Quarter2: item.Quarter2,
                  Quarter3: item.Quarter3 ,Quarter4: item.Quarter4});
            })
          }

          let dataForExcel: any = [];
          let workbook = new Workbook();
          let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
          worksheet.columns = [
            { header: 'Fields', key: 'fields', width: 50 },
            { header: 'Quarter 1', key: 'Quarter 1', width: 15 },
            { header: 'Quarter 2', key: 'Quarter 2', width: 15 },
            { header: 'Quarter 3', key: 'Quarter 3', width: 15 },
            { header: 'Quarter 4', key: 'Quarter 4', width: 15 }
          ]
          worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
    
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          newArray.forEach((element: any) => {
            dataForExcel.push(Object.values(element))
          });
    
          dataForExcel.forEach((d: any) => {
            let row = worksheet.addRow(d);
          })
          this.excelDownload(workbook, "Facility Benchmark");
          this.exportExcelLoader = false;
       
    
  }

  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
    
    Object.getOwnPropertyNames(this)
    .filter(propName => Array.isArray((<any>this)[propName]))
    .forEach(propName => (<any>this)[propName] = []);

  }
}
